export const config = {
  apiBaseUrl: "/gg-api",
  starparksApiBaseUrl: "/sp-api",
  webCloudPlayEnabled: import.meta.env.VITE_WEB_CLOUD_PLAY_ENABLED === "true",
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "",
  signalProxyUrl: import.meta.env.VITE_SIGNAL_PROXY_URL ?? "",
  mediaProxyUrl: import.meta.env.VITE_MEDIA_PROXY_URL ?? "",
  streaming: {
    turnHost: import.meta.env.VITE_TURN_HOST ?? location.hostname,
    turnUsername: import.meta.env.VITE_TURN_USERNAME ?? "jzcloud",
    turnCredential: import.meta.env.VITE_TURN_CREDENTIAL ?? "jzcloud"
  }
} as const;
